export default {
  PRO_NAME: 'Profy招聘管理系统',
  PAGE_TITLE:'',
  MENU_LIST: [
    // {
    //   menuName: '我的看板',
    //   iconName: 'el-icon-menu',
    //   url: '/dashboard/index'
    // },
    // {
    //   menuName: '人才管理',
    //   iconName: 'el-icon-suitcase-1',
    //   childMenus: [
    //     {
    //       menuName: '人才搜索',
    //       url: '/local/index',
    //     },
    //     {
    //       menuName: '领英搜索',
    //       url: '/linkedin/index',
    //     },
    //     {
    //       menuName: '人才订阅',
    //       url: '/subscription/index',
    //     }
    //   ]
    // },
    // {
    //   menuName: '招聘管理',
    //   iconName: 'el-icon-position',
    //   childMenus: [{
    //       menuName: '职位管理',
    //       url: '/position/index',
    //     },
    //     {
    //       menuName: '候选人管理',
    //       url: '/candidate/index',
    //     }
    //   ]
    // },
    // {
    //   menuName: '统计',
    //   iconName: 'el-icon-rank',
    //   iconLink: '',
    //   url: '/statistics/index'
    // },
    // {
    //   menuName: '设置',
    //   iconName: 'el-icon-setting',
    //   childMenus: [{
    //       menuName: '用户管理',
    //       childMenus: [{
    //           menuName: '小程序用户',
    //           url: '',
    //         },
    //         {
    //           menuName: '管理员设置',
    //           url: '/manager/index',
    //         },
    //         {
    //           menuName: '管理组设置',
    //           url: '/group/index',
    //         }
    //       ]
    //     },
    //     {
    //       menuName: 'Banner管理',
    //       url: '/banner/index',
    //     },
    //     {
    //       menuName: '简历助手',
    //       childMenus: [{
    //           menuName: '安装说明',
    //           url: '/helper/option',
    //         },
    //         {
    //           menuName: '常见问题',
    //           url: '/helper/faq',
    //         }
    //       ]
    //     }
    //   ]
    // },
    // {
    //   menuName: '演示',
    //   iconName: 'el-icon-help',
    //   childMenus: [{
    //       menuName: '人岗匹配',
    //       url: '',
    //     },
    //     {
    //       menuName: '人才地图',
    //       url: '',
    //     }
    //   ]
    // }
  ],
  DEGREE_LIST: [{
      label: '不限',
      value: 'unkown'
    },
    {
      label: '高中',
      value: '高中'
    },
    {
      label: '大专',
      value: '大专'
    },
    {
      label: '本科',
      value: '本科'
    },
    {
      label: '硕士',
      value: '硕士'
    },
    {
      label: '博士',
      value: '博士'
    }
  ],
  FINANCING_STATUS: [{
      label: '不需要融资',
      value: '不需要融资'
    },
    {
      label: '天使轮',
      value: '天使轮'
    },
    {
      label: 'A轮',
      value: 'A轮'
    },
    {
      label: 'B轮',
      value: 'B轮'
    },
    {
      label: 'C轮',
      value: 'C轮'
    },
    {
      label: 'D轮',
      value: 'D轮'
    },
    {
      label: '已上市',
      value: '已上市'
    }
  ],
  COMPANY_SIZE: [{
      label: "1-5人",
      value: "1-5"
    },
    {
      label: "6-20人",
      value: "6-20"
    },
    {
      label: "21-50人",
      value: "21-50"
    },
    {
      label: "51-100人",
      value: "51-100"
    },
    {
      label: "101-200人",
      value: "101-200"
    },
    {
      label: "201-500人",
      value: "201-500"
    },
    {
      label: "501-1000人",
      value: "501-1000"
    },
    {
      label: "1000人以上",
      value: "1000以上"
    }
  ],
  CITY_LIST: ["阿坝", "阿拉善", "阿里", "安康", "安庆", "鞍山", "安顺", "安阳", "澳门", "北京", "白银", "保定", "宝鸡", "保山", "包头", "巴中", "北海", "蚌埠", "本溪", "毕节", "滨州", "百色", "亳州", "重庆", "成都", "长沙", "长春", "沧州", "常德", "昌都", "长治", "常州", "巢湖", "潮州", "承德", "郴州", "赤峰", "池州", "崇左", "楚雄", "滁州", "朝阳", "大连", "东莞", "大理", "丹东", "大庆", "大同", "大兴安岭", "德宏", "德阳", "德州", "定西", "迪庆", "东营", "鄂尔多斯", "恩施", "鄂州", "福州", "防城港", "佛山", "抚顺", "抚州", "阜新", "阜阳", "广州", "赣州", "桂林", "贵阳", "甘南", "甘孜", "广安", "广元", "果洛", "贵港", "杭州", "哈尔滨", "合肥", "海口", "海东", "海北", "海南", "海西", "邯郸", "汉中", "鹤壁", "河池", "鹤岗", "黑河", "衡水", "衡阳", "河源", "贺州", "红河", "淮安", "淮北", "怀化", "淮南", "黄冈", "黄南", "黄山", "黄石", "惠州", "葫芦岛", "呼伦贝尔", "湖州", "菏泽", "济南", "佳木斯", "吉安", "江门", "焦作", "嘉兴", "嘉峪关", "揭阳", "吉林", "金昌", "晋城", "景德镇", "荆门", "荆州", "金华", "济宁", "晋中", "锦州", "九江", "酒泉", "昆明", "开封", "兰州", "拉萨", "来宾", "莱芜", "廊坊", "乐山", "凉山", "连云港", "聊城", "辽阳", "辽源", "丽江", "临沧", "临汾", "临夏", "临沂", "林芝", "丽水", "六安", "六盘水", "柳州", "陇南", "龙岩", "娄底", "漯河", "洛阳", "泸州", "吕梁", "马鞍山", "茂名", "眉山", "梅州", "绵阳", "牡丹江", "南京", "南昌", "南宁", "南充", "南平", "南通", "南阳", "那曲", "内江", "宁德", "怒江", "盘锦", "攀枝花", "平顶山", "平凉", "萍乡", "莆田", "濮阳", "青岛", "黔东南", "黔南", "黔西南", "庆阳", "清远", "秦皇岛", "钦州", "齐齐哈尔", "泉州", "曲靖", "衢州", "日喀则", "日照", "上海", "深圳", "苏州", "沈阳", "石家庄", "三门峡", "三明", "三亚", "商洛", "商丘", "上饶", "山南", "汕头", "汕尾", "韶关", "绍兴", "邵阳", "十堰", "朔州", "四平", "绥化", "遂宁", "随州", "宿迁", "宿州", "天津", "太原", "泰安", "泰州", "唐山", "天水", "铁岭", "铜川", "通化", "通辽", "铜陵", "铜仁", "台湾", "武汉", "乌鲁木齐", "无锡", "威海", "潍坊", "文山", "温州", "乌海", "芜湖", "乌兰察布", "武威", "梧州", "厦门", "西安", "西宁", "襄樊", "湘潭", "湘西", "咸宁", "咸阳", "孝感", "邢台", "新乡", "信阳", "新余", "忻州", "西双版纳", "宣城", "许昌", "徐州", "香港", "锡林郭勒", "兴安", "银川", "雅安", "延安", "延边", "盐城", "阳江", "阳泉", "扬州", "烟台", "宜宾", "宜昌", "宜春", "营口", "益阳", "永州", "岳阳", "榆林", "运城", "云浮", "玉树", "玉溪", "玉林", "杂多县", "赞皇县", "枣强县", "枣阳市", "枣庄", "泽库县", "增城市", "曾都区", "泽普县", "泽州县", "札达县", "扎赉特旗", "扎兰屯市", "扎鲁特旗", "扎囊县", "张北县", "张店区", "章贡区", "张家港", "张家界", "张家口", "漳平市", "漳浦县", "章丘市", "樟树市", "张湾区", "彰武县", "漳县", "张掖", "漳州", "长子县", "湛河区", "湛江", "站前区", "沾益县", "诏安县", "召陵区", "昭平县", "肇庆", "昭通", "赵县"].map(v => {
    return {
      label: v,
      value: v
    }
  }),
  STATUS_LIST: [
    {value: '0', label: "已投递"},
    {value: '1', label: "未通过"},
    {value: '2', label: "已通过"},
    {value: '3', label: "邀请面试"},
    {value: '4', label: "已入职"},
    {value: '5', label: "未入职"}
  ],
  CANDIDATE_STATUS: [
    { label:'全部',value:1 },
    { label:'候选人',value:2 },
    { label:'未通过',value:3 },
    { label:'已邀请面试',value:4 },
    { label:'已入职',value:5 },
    { label:'未入职',value:6 },
    { label:'已通过',value:7 },
  ],
  // 职能
  POSITION_LIST : [
    {title:'房地产', data:[
      {title:'总裁/副总裁'},
      {title:'区域总/城市总/项目总投资拓展'},
      {title:'开发报建'},
      {title:'规划设计'},
      {title:'工程管理'},
      {title:'酒店管理'},
      {title:'成本控制'},
      {title:'大运营管理'},
      {title:'物业管理'},
      {title:'商业管理'},
      {title:'融资/资金管理'},
      {title:'市场营销'},
      {title:'城市更新'},
      {title:'产业运营'}
    ]},
    {title:'财务与会计', data:[
      {title:'财务'},
      {title:'会计'},
      {title:'应收应付'},
      {title:'总帐'},
      {title:'成本'},
      {title:'分析'},
      {title:'审计'},
      {title:'税务'},
      {title:'资金'},
      {title:'信用'},
      {title:'控制'}
    ]},
    {title:'人力资源', data:[
      {title:'人力资源业务伙伴'},
      {title:'运营'},
      {title:'招聘'},
      {title:'薪酬与福利'},
      {title:'培训'},
      {title:'组织发展'},
      {title:'员工关系'},
      {title:'绩效'},
      {title:'人力资源规划'}
    ]},
    {title:'市场', data:[
      {title:'E-Commerce,Online Marketing,Digital Marketing'},
      {title:'Branding'},
      {title:'Trade Marketing'},
      {title:'PR'},
      {title:'Communication'},
      {title:'Market Research,Marketing Analysis'},
      {title:'Creative,Design'},
      {title:'Product Management'}
    ]},
    {title:'销售', data:[
      {title:'B2B Sales'},
      {title:'B2C Sales(Consumer)'},
      {title:'Channel Sales'},
      {title:'Telemarketing, Call Center Sales'},
      {title:'Sales management'},
    ]},
    {title:'IT', data:[
      {title:'技术'},
      {title:'设计'},
      {title:'数据'},
      {title:'产品'},
      {title:'业务分析运营'},
      {title:'市场与销售安全'}
    ]},
    {title:'大数据、云计算、算法、数据分析游戏娱乐', data:[{title:'大数据、云计算、算法、数据分析游戏娱乐'}]},
    {title:'项目', data:[{title:'项目'}]},
    {title:'高层管理', data:[{title:'高层管理'}]},
    {title:'运营', data:[{title:'运营'}]},
    {title:'客服', data:[{title:'客服'}]},
    {title:'行政', data:[{title:'行政'}]},
    {title:'生产', data:[{title:'生产'}]},
    {title:'工程', data:[{title:'工程'}]},
    {title:'研发', data:[{title:'研发'}]},
    {title:'质量', data:[{title:'质量'}]},
    {title:'EHS', data:[{title:'EHS'}]},
    {title:'技术支持', data:[{title:'技术支持'}]},
    {title:'法律', data:[{title:'法律'}]},
    {title:'设备', data:[{title:'设备'}]},
    {title:'采购', data:[{title:'采购'}]},
    {title:'供应链工艺', data:[{title:'供应链工艺'}]},
    {title:'秘书', data:[{title:'秘书'}]},
    {title:'公共关系', data:[{title:'公共关系'}]},
    {title:'Lean', data:[{title:'Lean'}]},
    {title:'供应商管理', data:[{title:'供应商管理'}]},
    {title:'售后市场', data:[{title:'售后市场'}]},
    {title:'行业专有', data:[{title:'行业专有'}]},
    {title:'其他', data:[{title:'其他'}]}
  ]
}



// WEBPACK FOOTER //
// ./src/store/state/index.js